//多合一读卡器
console.log('已加载多合一读卡器js文件')
import Vue from 'vue'
let cardNumberInput = document.getElementsByClassName('cpuCardUtilCardNumber')
var wsUri = 'ws://127.0.0.1:7846/ws'
var ws1
var msgid = 0
var websocket_supported = false
var read_timer = 200
var reader_timer_id
var reader_samid = ''

pageInit()

const intervalVal = setInterval(() => {
  findCPUCard()
  findIDCard()
}, 1000)

function pageInit() {
  readerInit()
}

function readerInit(wzxx) {
  if (websocket_supported == false || ws1.readyState == 2 || ws1.readyState == 3) {
    websocket_supported = wsOpen()
  }
  on_usb_dev_ready('')

  reader_timer_id = setTimeout(on_reader_detected, read_timer)
}

function on_usb_dev_ready(samid) {
  reader_samid = samid
  if (samid == '') {
    console.log('多合一读卡器未连接！')
  } else {
    console.log('多合一读卡器已连接(' + samid + ')！')
  }
}

function on_reader_detected() {
  if (websocket_supported && ws1.readyState == 1) {
    if (reader_samid == '') {
      //如果还没有检测到多合一读卡器，则先检测多合一读卡器
      doSend('idcard', 'getsam')
    }
  } else {
    if (reader_samid != '') {
      on_usb_dev_ready('')
      console.log('未检测到多合一读卡器插件!')
    }
  }
  clearTimeout(reader_timer_id)
  reader_timer_id = setTimeout(on_reader_detected, 5000)
}

function wsOpen() {
  if (typeof WebSocket == 'undefined') {
    return false
  }

  ws1 = new WebSocket(wsUri)
  ws1.onopen = function() {}
  ws1.onclose = function() {}

  ws1.onmessage = function(evt) {
    var jsondata = JSON.parse(evt.data)
    if (
      jsondata.module == 'iccard' &&
      jsondata.function == 'iso14443a_find' &&
      jsondata.data &&
      jsondata.data.uid &&
      jsondata.data.uid[0] &&
      [40].includes(jsondata.data.uid[0].sak) // 卡类型为40
    ) {
      //找卡，读取到cpu卡
      let cardNumberStr = jsondata.data.uid[0].text
      if (cardNumberStr && cardNumberStr.length === 8) {
        let cardNumberLowercase = cardNumberStr.toLowerCase() //卡号转小写
        if (
          cardNumberInput &&
          (!cardNumberInput[0].value ||
            cardNumberInput[0].value.toLowerCase() !== cardNumberLowercase)
        ) {
          //当输入框为空，或者值不相等时才赋值
          window.inputValue(cardNumberInput[0], cardNumberStr)
          beep()
        }
      }
    } else if (
      jsondata.module == 'idcard' &&
      jsondata.function == 'readcard' &&
      jsondata.data &&
      jsondata.data.number
    ) {
      //读到身份证
      const data = jsondata.data
      console.log('读到身份证信息')
      const idCardInfo = {
        name: data.name,
        sex: data.gender === '2' ? '女' : '男',
        born: data.birthday,
        frontImg: data.photo,
        userlifeb: data.valied,
        userlifee: data.expire,
        cardno: data.number,
        police: data.issuer,
        address: data.address,
        nation: getNation(data.race)
      }
      Vue.prototype.$carReaderIDCardInfo = idCardInfo
    } else if (jsondata.module == 'idcard' && jsondata.function == 'getsam') {
      //检测到多合一读卡器
      console.log('设备初始化信息：', jsondata)
      if (typeof jsondata.errorMsg == 'undefined') {
        if (reader_samid != jsondata.data.samid) {
          on_usb_dev_ready(jsondata.data.samid)
        }
      } else {
        //没有检测到多合一读卡器
        if (reader_samid != '') {
          on_usb_dev_ready('') //如果之前存在多合一读卡器，则通知多合一读卡器已拔出
        }
      }
    } else if (
      jsondata.module == 'idcard' &&
      jsondata.function == 'findcard' &&
      typeof jsondata.errorMsg == 'undefined'
    ) {
      //找卡成功后，开始选卡
      doSend('idcard', 'selectcard')
    } else if (
      jsondata.module == 'idcard' &&
      jsondata.function == 'selectcard' &&
      typeof jsondata.errorMsg == 'undefined'
    ) {
      //选卡成功后，开始读卡
      doSend('idcard', 'readcard')
    } else if (jsondata.module === 'common' || jsondata.function === 'beep') {
      //蜂鸣器回调
    } else if (jsondata.errorMsg && jsondata.errorMsg === '找卡失败') {
      console.log('读卡中....')
      if (jsondata.function === 'findcard') {
        // 身份证已移除
        Vue.prototype.$carReaderIDCardInfo = undefined
      }
    } else {
      console.log('接收到未处理数据：', jsondata)
    }
  }
  ws1.onerror = function(evt) {}

  return true
}

function findCPUCard() {
  msgid = msgid + 1
  if (websocket_supported && ws1.readyState == 1) {
    doSend('iccard', 'iso14443a_find')
  } else {
    console.log('未检测到多合一读卡器插件!')
  }
}

function findIDCard() {
  msgid = msgid + 1
  if (websocket_supported && ws1.readyState == 1) {
    doSend('idcard', 'findcard')
  } else {//读CPU 卡已经有输出错误
    //console.log('未检测到多合一读卡器插件!')
  }
}

function doSend(module, fun) {
  msgid = msgid + 1
  ws1.send('{"module":"' + module + '","msgid":"' + msgid + '","function":"' + fun + '"}')
}

function beep() {
  msgid = msgid + 1
  var msg = {
    module: 'common',
    msgid: msgid.toString(),
    function: 'beep',
    data: {
      length: 100
    }
  }

  ws1.send(JSON.stringify(msg))
}

//js模拟实现输入框input事件
window.inputValue = function(dom, st) {
  var evt = new InputEvent('input', {
    inputType: 'insertText',
    data: st,
    dataTransfer: null,
    isComposing: false
  })
  dom.value = st
  dom.dispatchEvent(evt)
}

function getNation(nationVal) {
  let result = ''
  switch (nationVal) {
    case '01':
      result = '汉'
      break
    case '02':
      result = '蒙古'
      break
    case '03':
      result = '回'
      break
    case '04':
      result = '藏'
      break
    case '05':
      result = '维吾尔'
      break
    case '06':
      result = '苗'
      break
    case '07':
      result = '彝'
      break
    case '08':
      result = '壮'
      break
    case '09':
      result = '布依'
      break
    case '10':
      result = '朝鲜'
      break
    case '11':
      result = '满'
      break
    case '12':
      result = '侗'
      break
    case '13':
      result = '瑶'
      break
    case '14':
      result = '白'
      break
    case '15':
      result = '土家'
      break
    case '16':
      result = '哈尼'
      break
    case '17':
      result = '哈萨克'
      break
    case '18':
      result = '傣'
      break
    case '19':
      result = '黎'
      break
    case '20':
      result = '傈僳'
      break
    case '21':
      result = '佤'
      break
    case '22':
      result = '畲'
      break
    case '23':
      result = '高山'
      break
    case '24':
      result = '拉祜'
      break
    case '25':
      result = '水'
      break
    case '26':
      result = '东乡'
      break
    case '27':
      result = '纳西'
      break
    case '28':
      result = '景颇'
      break
    case '29':
      result = '柯尔克孜'
      break
    case '30':
      result = '土'
      break
    case '31':
      result = '达翰尔'
      break
    case '32':
      result = '仫佬'
      break
    case '33':
      result = '羌'
      break
    case '34':
      result = '布朗'
      break
    case '35':
      result = '撒拉'
      break
    case '36':
      result = '毛南'
      break
    case '37':
      result = '仡佬'
      break
    case '38':
      result = '锡伯'
      break
    case '39':
      result = '阿昌'
      break
    case '40':
      result = '普米'
      break
    case '41':
      result = '塔吉克'
      break
    case '42':
      result = '怒'
      break
    case '43':
      result = '乌孜别克'
      break
    case '44':
      result = '俄罗斯'
      break
    case '45':
      result = '鄂温克'
      break
    case '46':
      result = '德昂'
      break
    case '47':
      result = '保安'
      break
    case '48':
      result = '裕固'
      break
    case '49':
      result = '京'
      break
    case '50':
      result = '塔塔尔'
      break
    case '51':
      result = '独龙'
      break
    case '52':
      result = '鄂伦春'
      break
    case '53':
      result = '赫哲'
      break
    case '54':
      result = '门巴'
      break
    case '55':
      result = '珞巴'
      break
    case '56':
      result = '基诺'
      break
    case '59':
      result = '穿青人'
      break
    case '60':
      result = '革家人'
      break
    case '97':
      result = '其它'
      break
    case '98':
      result = '入籍'
      break
    case '99':
      result = '其它'
      break
    default:
      break
  }
  return result
}
